// ===============================================================
//
// Delete popup model for CAD topology
// Called from CAD topology page
//
//
// 
//
//
// ===============================================================

import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { deleteTopologyData } from './../../../../actions/closeLoop/topology/index';

class DeleteTopologyDataModel extends Component {
    constructor(props){
        super(props)
        // Setting default values
        this.state = {
            data: undefined,
            togglePopup: false,
            popUpText: undefined
        }
        this.handleDeleteContent = this.handleDeleteContent.bind(this);
        this.closePopupModal = this.closePopupModal.bind(this);
    }

    // Delete function
    handleDeleteContent() {
        console.log("UUID passed to delete JSONN Modal",this.props.deleteJobUuid)
        // API call to delete the cad data from the databaseconst payload = {
        const payload = {
            topologyId: this.props.deleteJobUuid
        };
        console.log(payload);
        this.props.deleteTopologyData(payload);
        this.props.handleCloseDeleteModal();
    }
    // Close popup modal function
    closePopupModal() {
        this.setState( (prevState) => {
            return {
                ...prevState,
                togglePopup: false
            }
        })
        // Close the delete modal
        this.props.handleCloseDeleteModal();
    }

    componentDidMount() {
        // this.setState( (prevState) => {
        //     return {
        //         ...prevState,
        //         data: this.props.deleteContent
        //     }
        // })
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.deleteSelectedRow>=0}>
                    <ModalHeader
                        toggle={this.props.handleCloseDeleteModal}
                        style={{ color:"#524fa1" }}
                    >
                        Delete CAD Topology
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            Are you sure want to delete ?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn" style={{marginLeft: "70%",color:"#FFFFFF", backgroundColor: "red" }} onClick={this.handleDeleteContent}>Delete</Button>
                      <Button className="btn" style={{marginRight: "30%",color:"#FFFFFF"}} onClick={this.props.handleCloseDeleteModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
DeleteTopologyDataModel.propTypes={
deleteSelectedRow:PropTypes.string,
deleteJobUuid:PropTypes.string,
handleCloseDeleteModal:PropTypes.func,

}
DeleteTopologyDataModel.defaultProps= {
deleteSelectedRow:[],
deleteJobUuid:[],
}

const mapDispatchToProps = (dispatch) => ({
    deleteTopologyData: (payload) => dispatch(deleteTopologyData(payload)),
});

export default connect(undefined, mapDispatchToProps)(DeleteTopologyDataModel);
